module.exports = __webpack_public_path__ + "static/poster-22b15f7c5e6ee215a4faa7a1346b81c6.jpg";